import { useTranslation } from 'react-i18next'
import { MdKey, MdQuestionMark } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'

import { Button, Layout, Text } from '../../components'
import { PATH, Requirement } from '../../constants'
import { useContactProvider, useDeviceIdProvider } from '../../hooks'

export function SelectRequirementFrame() {
  const navigate = useNavigate()
  const { setRequirement } = useContactProvider()
  const { getRoute } = useDeviceIdProvider()
  const { i18n } = useTranslation()
  const ja = i18n.getFixedT(
    'ja',
    'translation',
    'frames.SelectRequirementFrame'
  )
  const en = i18n.getFixedT(
    'en',
    'translation',
    'frames.SelectRequirementFrame'
  )
  return (
    <Layout>
      <div className="wide:mt-[20px] wide:gap-y-[20px] mt-[60px] flex w-full flex-col items-center gap-y-[40px]">
        <Text size="heading3" align="center">
          {ja('information')}
          <br />
          {en('information')}
        </Text>
        <div className="flex gap-x-[70px]">
          <Button
            className="h-[230px] w-[350px]"
            size="l"
            square
            fill
            onHover={(e) => e.preventDefault()}
            onClick={() => {
              setRequirement(Requirement.CheckIn)
              navigate(getRoute(PATH.selectLanguage))
            }}
          >
            <div className="flex flex-col items-center justify-center gap-3">
              <Text size="lg3" align="center">
                {ja('checkin')}
                <br />
                {en('checkin')}
              </Text>
              <MdKey size={70} />
            </div>
          </Button>
          <Button
            className="h-[230px] w-[350px]"
            size="l"
            square
            gold
            onHover={(e) => e.preventDefault()}
            onClick={() => {
              setRequirement(Requirement.Other)
              navigate(getRoute(PATH.selectLanguage))
            }}
          >
            <div className="flex flex-col items-center justify-center gap-3">
              <Text size="lg3" align="center">
                {ja('other')}
                <br />
                {en('other')}
              </Text>
              <MdQuestionMark size={70} />
            </div>
          </Button>
        </div>
        <div>
          <a
            href={getRoute(PATH.root)}
            onClick={(e) => {
              e.preventDefault()
              navigate(getRoute(PATH.root))
            }}
          >
            <Text className="underline" size="lg2">
              {ja('back')}
              <br />
              {en('back')}
            </Text>
          </a>
        </div>
      </div>
    </Layout>
  )
}
